import GeneralFactory from 'coreClasses/GeneralFactory';
import {registerModuleStateReset} from 'coreUtils/moduleState';
import VariantModel from './VariantModel';
import ProductModel from './ProductModel';
import AbstractProductModel from './AbstractProductModel';
import {Product} from '../../store/data/products/types';

const productsMap = new Map<string, AbstractProductModel>();

registerModuleStateReset(() => productsMap.clear());

/**
 * Represents ProductFactory
 */
class ProductFactory extends GeneralFactory {
	/**
	 * Creates analytics provider
	 * @param {Product} productData - productData
	 */
	create(productData: Product): AbstractProductModel {
		const productKey = productData?.id || 'placeholder';

		let cachedModel = productsMap.get(productKey);

		if (!cachedModel || cachedModel.getUpdateTimestamp() < productData?.updated) {
			switch (productData?.type?.variant) {
				case true:
					cachedModel = new VariantModel(this.managerRepository, productData);

					break;
				default:
					cachedModel = new ProductModel(this.managerRepository, productData);
			}

			productsMap.set(productKey, cachedModel);
		}

		return cachedModel;
	}
}

export default ProductFactory;
